export const capitalize = (string = '') => (string || '').charAt(0).toUpperCase() + string.slice(1);
export const capitalizeAllWords = (string = '') => ((string || '').replaceAll(/[-_\s]+/g, ' '))
    .replaceAll(/\s+/g, ' ').trim().split(' ').map(capitalize).join(' ');
